import React from "react";
import { useNavigate } from "react-router-dom";
import "./index.css"; // Import external CSS

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404</h1>
      <h2 className="not-found-subtitle">Oops! Page Not Found</h2>
      <p className="not-found-text">
        The page you are looking for doesn’t exist or has been moved.
      </p>

      {/* Illustration */}
      <img
        src="https://i.imgur.com/qIufhof.png"
        alt="Page Not Found"
        className="not-found-image"
      />

      {/* Go Home Button */}
      <button onClick={() => navigate("/")} className="not-found-button">
        Go to Homepage
      </button>
    </div>
  );
};

export default NotFound;
